import _ from "lodash";
import Radium from "radium";
import React from "react";

import ApiKeyListItem from "./api-key-list-item";
import { styles } from "@common/styles";
import { IApiKey } from "@common/models";
import { random } from "@common";

export interface IApiKeyListProps {
  editApiKey: (apikey: IApiKey) => void;
  apiKeys: IApiKey[];
}

class ApiKeyList extends React.Component<IApiKeyListProps, any> {
  public render() {
    const userHasApiKeys = this.props.apiKeys && this.props.apiKeys.length > 0;
    const listItemStyle = { ...styles.listItem, fontSize: "13px" };
    const wideItemStyle = { ...listItemStyle, width: "60%", flex: "3" };

    return (
      <div style={userHasApiKeys ? wideItemStyle : (listItemStyle as any)}>
        <div style={styles.subItem as any}>
          {userHasApiKeys ? (
            this.props.apiKeys.map(apikey => {
              const uniqueKey = random();
              return (
                <ApiKeyListItem
                  key={uniqueKey}
                  apiKey={apikey}
                  editApiKey={this.props.editApiKey}
                />
              );
            })
          ) : (
            <div>Ingen API-nøkler</div>
          )}
        </div>
      </div>
    );
  }
}

export default Radium(ApiKeyList);
